import type { AffShowType, Info, UserAction } from '~~/api/interface/user'
import type { Locale } from '~/build/i18n'

export const userStore = defineStore(
  'user',
  () => {
    function init(): Info {
      return {
        area: '',
        avatar: '',
        bgImg: '',
        bindType: [],
        content: '',
        countryCode: '',
        email: '',
        light: 0,
        lightStatus: 0,
        likeNum: 0,
        notifyStatus: 0,
        nickName: '',
        topicType: 1, // 1是黑 3是白
        userId: '',
        userName: '',
        outUserId: '',
        cpToken: '',
        isReg: 0,
        avatarFrameUrl: '',
        uidFromToken: '',
        vip: false,
        vipEndTimestamp: 0,
        affShowType: 'unShowMenu',
      }
    }

    const userInfo = ref<Info>(init())
    const spaceToken = ref<string>()
    const { $i18n } = useNuxtApp()
    const { defaultLocale } = $i18n

    function storeUserInfo(info: Info) {
      if (info && info.userId) {
        userInfo.value = info

        info?.spaceToken && (spaceToken.value = info?.spaceToken)
        return
      }

      cleanUserInfo()
    }

    const isLogined = computed(() => userInfo.value?.userId !== '')
    const userLocale = ref<Locale>(defaultLocale)

    function userActionDefaults() {
      return {
        coinCount: 0,
        couponCount: 0,
        /** 消息-通知未读数 */
        noticeMessageCount: 0,
        /** 消息-促销未读数 */
        promotionMessageCount: 0,
        /** 待评价数量 */
        toReviews: 0,
        orderCountOnCancel: 0,
        orderCountOnComplete: 0,
        orderCountOnUnpaid: 0,
        orderCountOnProgress: 0,
        orderCountOnRefund: 0,
        hasNotify: false,
        formatPrice: '',
        inviteCount: 0,
        toReviewsUnRead: false,
        isKOL: false,
        avatarBadge: 0,
        hasRechargeTip: false,
        affShowType: 'unShowMenu' as AffShowType,
      }
    }

    const userAction = reactive<UserAction>(userActionDefaults())

    function setUserAction(info: Partial<UserAction>) {
      loMerge(userAction, info)
    }

    function resetUserAction() {
      loMerge(userAction, userActionDefaults())
    }

    function cleanUserInfo() {
      userInfo.value = init()
      spaceToken.value = ''
      resetUserAction()

      // 清除 plugin 同步写入的 localStorage 数据
      if (import.meta.client) {
        localStorage.removeItem('userInfo')
        localStorage.removeItem('userAction')
        localStorage.removeItem('userLocale')
      }
      // 清除 spaceToken cookie
      const spaceTokenCookie = useCookie('spaceToken')
      spaceTokenCookie.value = null
    }

    // 用于App传过来的token
    const appToken = ref<string>()
    /** app是否已登陆 */
    const appIsLogined = computed(() => !!appToken.value)

    function setAppToken(token: string) {
      appToken.value = token
    }

    return {
      userInfo,
      storeUserInfo,
      cleanUserInfo,
      isLogined,
      userLocale,
      spaceToken,
      appIsLogined,
      setAppToken,

      userAction,
      setUserAction,
    }
  },
  {
    // https://prazdevs.github.io/pinia-plugin-persistedstate/frameworks/nuxt-3.html
    persist: true,
  },
)

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(userStore, import.meta.hot))
}
